/**
 * The store's social links for the footer. boxed parity (`components/shared/footer/index.tsx`
 * there): the same six networks as icon links, except that boxed's are constants and these are
 * the tenant's own from the resolved config, so an unset network is not shown.
 */
import { type SocialLinks, socialLinksSchema } from "@loot-os/api-contract";

import type { TenantConfig } from "./tenant.js";

const NONE: SocialLinks = {};

/**
 * Fail-closed read: a config cached by an older BFF or in sessionStorage has no `socialLinks`,
 * and every value here becomes an `href`, so the field is checked against the schema once more
 * at the sink and anything that does not pass shows no icons at all.
 */
export function socialLinksOf(config: TenantConfig): SocialLinks {
  const result = socialLinksSchema.safeParse((config as Partial<TenantConfig>).socialLinks);
  return result.success ? result.data : NONE;
}
